import gql from 'graphql-tag';
import { useState } from 'react';
import useQueryFacade from '../useQueryFacade';
import {
    provideApolloClient
} from '@vue/apollo-composable';

import { apolloClient } from '../../src/apollo/index';
import useQuoteTools from '../useQuoteTools';
// const apolloClient = new ApolloClient({
//     link: httpLink,
//     cache,
//   })
  
  provideApolloClient(apolloClient);

  const stagedQuoteResponseFormat = `
    stagedQuoteState
    id
    version
    sellerComment
    createdAt
    quoteRequest {
        id
        comment
        version
    }
    createdBy {
        clientId
        isPlatformClient
    }
    customer {
        id
        customerGroup {
            id
        }
    }
    lastModifiedAt
    lastModifiedBy {
        clientId
        isPlatformClient
    }
    quotationCart {
        customerId
        lineItems {
            lineId: id
            productId
            name(locale: $locale)
            productSlug(locale: $locale)
            quantity
            price {
                value {
                    centAmount
                    currencyCode
                    fractionDigits
                }
                discounted {
                    value {
                        centAmount
                        currencyCode
                        fractionDigits
                    }
                    discount {
                        name(locale: $locale)
                    }
                }
            }
            totalPrice {
                centAmount
                currencyCode
                fractionDigits
            }
            variant {
                sku
                images {
                url
                }
                attributesRaw {
                    name
                    value
                    attributeDefinition {
                        type {
                            name
                        }
                        name
                        label(locale: $locale)
                    }
                }
            }
        }
        totalPrice {
            centAmount
            currencyCode
            fractionDigits
        }
        shippingInfo {
            shippingMethod {
                name
                localizedDescription(locale: $locale)
            }
            price {
                centAmount
                currencyCode
                fractionDigits
            }
        }
        taxedPrice {
            totalGross {
                centAmount
                currencyCode
                fractionDigits
            }
            totalNet {
                centAmount
                currencyCode
                fractionDigits
            }
        }
        shippingAddress {
            firstName
            lastName
            streetName
            additionalStreetInfo
            postalCode
            city
            country
            phone
            email
        }
        billingAddress {
            firstName
            lastName
            streetName
            additionalStreetInfo
            postalCode
            city
            country
            phone
            email
        }
        paymentInfo {
            payments {
                paymentStatus {
                interfaceCode
                }
            }
        }
        directDiscounts {
            id
            value{
                type
                ...on RelativeDiscountValue{
                    permyriad
                }
            }
            target{
                type
                ...on LineItemsTarget {
                    predicate
                }
            }
        }
        cartState
        id
        version
    }`;

const quoteRequestQuery = gql `
    query quoteRequestById($id: String, $locale: Locale!) {
        quoteRequest(id: $id) {
            id
            version
            comment
            country
            createdAt
            quoteRequestState
            createdBy {
                clientId
                isPlatformClient
            }
            customer {
                id
                customerGroup {
                    id
                }
            }
            lastModifiedAt
            lastModifiedBy {
                clientId
                isPlatformClient
            }
            lineItems {
                lineId: id
                productId
                name(locale: $locale)
                productSlug(locale: $locale)
                quantity
                price {
                    value {
                    centAmount
                    currencyCode
                    fractionDigits
                    }
                    discounted {
                    value {
                        centAmount
                        currencyCode
                        fractionDigits
                    }
                    discount {
                        name(locale: $locale)
                    }
                    }
                }
                totalPrice {
                    centAmount
                    currencyCode
                    fractionDigits
                }
                variant {
                    sku
                    images {
                    url
                    }
                    attributesRaw {
                        name
                        value
                        attributeDefinition {
                            type {
                                name
                            }
                            name
                            label(locale: $locale)
                        }
                    }
                }
            }
            totalPrice {
                centAmount
                currencyCode
                fractionDigits
            }
            shippingInfo {
                shippingMethod {
                    name
                    localizedDescription(locale: $locale)
                }
                price {
                    centAmount
                    currencyCode
                    fractionDigits
                }
            }
            taxedPrice {
                totalGross {
                    centAmount
                    currencyCode
                    fractionDigits
                }
                totalNet {
                    centAmount
                    currencyCode
                    fractionDigits
                }
            }
            shippingAddress {
                firstName
                lastName
                streetName
                additionalStreetInfo
                postalCode
                city
                country
                phone
                email
            }
            billingAddress {
                firstName
                lastName
                streetName
                additionalStreetInfo
                postalCode
                city
                country
                phone
                email
            }
            paymentInfo {
                payments {
                    paymentStatus {
                    interfaceCode
                    }
                }
            }
        }
    }
`;

const quoteByIdQuery = gql `
     query queryMyQuoteById($locale: Locale!, $where: String ){
         quotes(where: $where) {
             results{
                 id
                 version
                 buyerComment
                 quoteState
                 sellerComment
                 country
                 createdAt
                 quoteRequest {
                     id
                     comment
                     version
                 }
                 stagedQuote {
                     id
                 }
                 createdBy {
                     clientId
                     isPlatformClient
                 }
                 customer {
                     id
                     customerGroup {
                         id
                     }
                 }
                 lastModifiedAt
                 lastModifiedBy {
                     clientId
                     isPlatformClient
                 }
                 lineItems {
                     lineId: id
                     productId
                     name(locale: $locale)
                     productSlug(locale: $locale)
                     quantity
                     price {
                         value {
                             centAmount
                             currencyCode
                             fractionDigits
                         }
                         discounted {
                             value {
                                 centAmount
                                 currencyCode
                                 fractionDigits
                             }
                             discount {
                                 name(locale: $locale)
                             }
                         }
                     }
                     totalPrice {
                         centAmount
                         currencyCode
                         fractionDigits
                     }
                     variant {
                         sku
                         images {
                         url
                         }
                         attributesRaw {
                             name
                             value
                             attributeDefinition {
                                 type {
                                     name
                                 }
                                 name
                                 label(locale: $locale)
                             }
                         }
                     }
                 }
                 totalPrice {
                     centAmount
                     currencyCode
                     fractionDigits
                 }
                 shippingInfo {
                     shippingMethod {
                         name
                         localizedDescription(locale: $locale)
                     }
                     price {
                         centAmount
                         currencyCode
                         fractionDigits
                     }
                 }
                 taxedPrice {
                     totalGross {
                         centAmount
                         currencyCode
                         fractionDigits
                     }
                     totalNet {
                         centAmount
                         currencyCode
                         fractionDigits
                     }
                 }
                 shippingAddress {
                     firstName
                     lastName
                     streetName
                     additionalStreetInfo
                     postalCode
                     city
                     country
                     phone
                     email
                 }
                 billingAddress {
                     firstName
                     lastName
                     streetName
                     additionalStreetInfo
                     postalCode
                     city
                     country
                     phone
                     email
                 }
                 paymentInfo {
                     payments {
                         paymentStatus {
                         interfaceCode
                         }
                     }
                 }
                 directDiscounts {
                    id
                    value{
                        type
                        ...on RelativeDiscountValue{
                            permyriad
                        }
                    }
                    target{
                        type
                        ...on LineItemsTarget {
                            predicate
                        }
                    }
                 }
             }
         }
 }
 `;

const queryStagedQuote = gql `
    query QueryStagedQuote($where: String!, $locale: Locale!) {
    stagedQuotes(where: $where) {
        results {
            ${stagedQuoteResponseFormat}
        }
    }
}
`;

function useMyQuote({ id, locale, queryParam }) {
    const [quote, setQuote] = useState(null);
    const [query, setQuery] = useState(null);
    const [whereQuoteId, setWhereQuoteId] = useState(null);
    setWhereQuoteId(`quoteRequest(id="${id.value}")`)
    // let whereValue;
    if(queryParam.value === "Accepted") {
        setQuery(queryStagedQuote);
        // whereValue = `quoteRequest(id="${id.value}")`;
        setWhereQuoteId(`quoteRequest(id="${id.value}")`);
    } else {
        setQuery(quoteRequestQuery);
    }

    const fetchData = () => {
       return useQueryFacade(query.value, {
            variables: { id, locale,'where': whereQuoteId.value? whereQuoteId.value: '' },
            onCompleted: (data) => {
              if (!data) {
                return;
              }
              let quote;
              if(queryParam.value === "Accepted") {
                  quote = data.stagedQuotes.results[0];
              } else {
                  quote = data.quoteRequest;
              }
      
              if(quote && quote.lineItems){
                  setQuote({
                      ...quote,
                      lineItems: quote?.lineItems
                        .map((item) => {return item;})
                        .filter(({ quantity }) => Boolean(quantity))
                  });
              } else if(quote && quote.quotationCart){
                  setQuote({
                      ...quote,
                      lineItems: quote?.quotationCart?.lineItems
                        .map((item) => {return item;})
                        .filter(({ quantity }) => Boolean(quantity)),
                        ...quote.quotationCart,
                        id: quote.id,
                        quotationCartId: quote.quotationCart.id,
                        comment: quote.quoteRequest?.comment
      
                  });
              } else {
                  setQuote({})
              }
            },
          });
    }

    const getMyQuote = async () => {
        return await useQueryFacade(quoteByIdQuery, {
            variables: { id, locale,'where': whereQuoteId.value? whereQuoteId.value: '' }
        });
    }

    const addSellerComment = async (stagedQuoteVersion, stagedQuoteId, comment) => {
        return await apolloClient.mutate({
            mutation: gql `
                mutation UpdateStagedQuote($version: Long!, $actions: [StagedQuoteUpdateAction!]!, $id: String, $locale: Locale) {
                    updateStagedQuote(version: $version, actions: $actions, id: $id) {
                        ${stagedQuoteResponseFormat}
                    }
                }
            `,
            variables: {
                version: parseInt(stagedQuoteVersion),
                id: stagedQuoteId,
                actions: [
                    {
                        setSellerComment: {
                            sellerComment: comment
                        }
                    }
                ],
                locale: locale.value
            }
        });
    }

    const sendStagedQuote = async (stagedQuoteVersion, stagedQuoteId) => {
        let actions = [
            {
                changeStagedQuoteState: {
                    stagedQuoteState: "Sent"
                }
            }
        ];

        return await apolloClient.mutate({
            mutation: gql `
                mutation UpdateStagedQuote($version: Long!, $actions: [StagedQuoteUpdateAction!]!, $id: String, $locale: Locale) {
                    updateStagedQuote(version: $version, actions: $actions, id: $id) {
                        ${stagedQuoteResponseFormat}
                    }
                }
            `,
            variables: {
                version: parseInt(stagedQuoteVersion),
                id: stagedQuoteId,
                actions: actions,
                locale: locale.value
            }
        });
    }

    const { loading, error, refetch } = fetchData();
    const createStagedQuote = (quoteRequestId, quoteRequestVersion) => {
        return apolloClient.mutate({
            mutation: gql`
                mutation CreateStagedQuote($draft: StagedQuoteDraft!) {
                    createStagedQuote(draft: $draft) {
                        id
                        version
                    }
                }
            `,
            variables: {
                draft: {
                    quoteRequest: {
                        id: quoteRequestId
                    },
                    quoteRequestVersion: parseInt(quoteRequestVersion)
                }
            }
        });
    }

    
    
    const acceptQuoteRequest = () => {
        const { changeQuoteRequestState } = useQuoteTools();
        return changeQuoteRequestState(quote.value.version, quote.value.id, 'Accepted')
        .then((updateQuoteRequestResponse)=> {
            // Create staged quote
            return createStagedQuote(updateQuoteRequestResponse.data.updateQuoteRequest.id, updateQuoteRequestResponse.data.updateQuoteRequest.version)
            .then(() => {
                setQuery(queryStagedQuote)
                return fetchData();
            })
        })
        .catch(err => console.error(err))
    }

    const getQuotationCart = () => {
        return quote.value.quotationCart;
    }

    const rejectQuoteRequest = () => {
        return apolloClient.mutate({
            mutation: gql `
                mutation UpdateQuoteRequest($version: Long!, $actions: [QuoteRequestUpdateAction!]!, $id: String) {
                    updateQuoteRequest(version: $version, actions: $actions, id: $id) {
                        quoteRequestState
                        id
                        version
                    }
                }
            `,
            variables: {
                version: parseInt(quote.value.version),
                id: quote.value.id,
                actions: {
                    changeQuoteRequestState: {
                        quoteRequestState: 'Rejected'
                    }
                }
            }
        }).then(()=> {
            setQuery(quoteRequestQuery)
            return fetchData();
        })
        .catch(err => console.error(err))
    }
    return { loading, error, quote, getMyQuote, acceptQuoteRequest, sendStagedQuote, rejectQuoteRequest, getQuotationCart, quoteRefetch: refetch, addSellerComment};
  }
  export default useMyQuote;